<form autocomplete="off" class="p-0" novalidate [formGroup]="codeForm">
  <div class="col-lg-12 col-md-12">
    <div class="card custom-card ">
      <div class="mt-3">
        <div *ngIf="submitButton">
          <h3 class="main-content-label mb-1"><b>{{ 'header.code-data.table.AddNewCodeRecord' | translate
              }}</b></h3>
          <p class="text-muted card-sub-title mb-0">{{ 'header.code-data.table.AddNewCodeInformation' | translate
            }} </p>
        </div>
        <div *ngIf="editButton">
          <h3 class="main-content-label mb-1"><b>{{ 'header.code-data.table.UpdateCodeRecord' | translate
              }}</b></h3>
          <p class="text-muted card-sub-title mb-0">{{ 'header.code-data.table.UpdateSelectedCodeInformation' |
            translate }} </p>
        </div>
        <div *ngIf="deleteButton">
          <h3 class="main-content-label mb-1"> <b>{{'header.code-data.table.DeleteCodeRecord' | translate}} </b>
          </h3>
          <p class="text-muted card-sub-title mb-0"> {{'header.code-data.table.DeleteSelectedCodeInformation' |
            translate}} </p>
        </div>
        <div class="row clearfix mt-3">
          <div class="col-sm-4">
            <div class="form-group">
              <div class="">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{ 'header.code-data.table.CodeType' | translate }}</mat-label> <input
                    onkeydown="return (event.keyCode!=13);" matInput readonly formControlName="CdType">
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <div class="">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{ 'header.code-data.table.CodeDescription' | translate }}</mat-label> <input
                    onkeydown="return (event.keyCode!=13);" matInput readonly formControlName="desLabel">
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <div class="">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{ 'header.code-data.table.Code' | translate }}</mat-label>
                  <input [readonly]="isReadonly" onkeydown="return (event.keyCode!=13);" matInput
                    formControlName="CdCode" placeholder="Code" maxlength="6" required>
                  <mat-error class="margin_tp"
                    *ngIf="codeForm.controls['CdCode'].touched && codeForm.controls['CdCode'].errors?.required">
                    {{ 'header.code-data.table.Mandatory' | translate }}
                  </mat-error>
                  <mat-error class="margin_tp"
                    *ngIf="codeForm.controls['CdCode'].touched && codeForm.controls['CdCode'].errors?.pattern">
                    {{ 'header.code-data.table.Invalid' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <div class="">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{ 'header.code-data.table.CodeDescription' | translate }}</mat-label> <input
                    onkeydown="return (event.keyCode!=13);" matInput formControlName="CdDesc"
                    [readonly]="isReadonlyDelete" maxlength="50" placeholder="Code Description" required>
                  <mat-error class="margin_tp"
                    *ngIf="codeForm.controls['CdDesc'].touched && codeForm.controls['CdDesc'].errors?.required">
                    {{ 'header.code-data.table.Mandatory' | translate }}
                  </mat-error>
                  <mat-error class="margin_tp"
                    *ngIf="codeForm.controls['CdDesc'].touched && codeForm.controls['CdDesc'].errors?.pattern">
                    {{ 'header.code-data.table.Invalid' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <div class="">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{ 'header.code-data.table.CodeSequence' | translate }}</mat-label> <input
                    onkeydown="return (event.keyCode!=13);" matInput formControlName="CdSeq" maxlength="4"
                    [readonly]="isReadonlyDelete" placeholder="Code Sequence" required>
                  <mat-error class="margin_tp"
                    *ngIf="codeForm.controls['CdSeq'].touched && codeForm.controls['CdSeq'].errors?.required">
                    {{ 'header.code-data.table.Mandatory' | translate }}
                  </mat-error>
                  <mat-error class="margin_tp"
                    *ngIf="codeForm.controls['CdSeq'].touched && codeForm.controls['CdSeq'].errors?.pattern">
                    {{ 'header.code-data.table.Invalid' | translate }}
                  </mat-error>
                  <mat-error class="margin_tp"
                    *ngIf="codeForm.controls['CdSeq'].touched && codeForm.controls['CdSeq'].errors?.maxlength">
                    Enter maximum 4 digits
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <div class="">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>{{ 'header.code-data.table.CodeProc' | translate }}</mat-label> <input
                    onkeydown="return (event.keyCode!=13);" matInput formControlName="CdProc"
                    [readonly]="isReadonlyDelete" placeholder="CdProc" maxlength="25" required>
                  <mat-error class="margin_tp"
                    *ngIf="codeForm.controls['CdProc'].touched && codeForm.controls['CdProc'].errors?.required">
                    {{ 'header.code-data.table.Mandatory' | translate }}
                  </mat-error>
                  <mat-error class="margin_tp"
                    *ngIf="codeForm.controls['CdProc'].touched && codeForm.controls['CdProc'].errors?.pattern">
                    {{ 'header.code-data.table.Invalid' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <div class="">
                <div class="row">
                  <div class="col-sm-4 mt-3">
                    <mat-label class="mt-1 lclass">
                      <span class="required-asterisk mr-1 mt-4">{{
                        'header.code-data.table.CodeActive' | translate }}</span>

                    </mat-label>
                  </div>
                  <div class="col-sm-7 mt-3">
                    <mat-radio-group [disabled]="isReadonlyDelete" onkeydown="return (event.keyCode!=13);"
                      formControlName="CdActive" class="example-full-width">
                      <div class="row">
                        <div class="col-sm-5">
                          <mat-radio-button value='Y'>{{ 'header.code-data.table.Yes' | translate }}</mat-radio-button>
                        </div>
                        <div class="col-sm-5">
                          <mat-radio-button value='N'>{{ 'header.code-data.table.No' | translate }}</mat-radio-button>
                        </div>
                      </div>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12"> <button type="button"
              class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
              *ngIf="submitButton && CodeCreate" (click)="submit()">{{ 'header.code-data.table.Submit' | translate
              }}</button> <button type="button"
              class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
              *ngIf="editButton && CodeUpdate" (click)="update()">{{ 'header.code-data.table.Update' | translate
              }}</button> <button type="button"
              class="  btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
              *ngIf="deleteButton && CodeDelete" (click)="openConformationModalBox()">{{'header.code-data.table.Delete'
              | translate }}
            </button> <button type="button"
              class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
              (click)="back()">{{ 'header.code-data.table.Back' | translate }}</button> </div>
        </div>
        <hr *ngIf="showTable">
        <div *ngIf="showTable">
          <h3 class="main-content-label mb-1"> <b>{{'header.code-data.table.List'|translate}}</b> </h3>
          <p class="text-muted card-sub-title mb-0">{{ 'header.code-data.table.CodeData' | translate }}</p>
        </div>
        <hr *ngIf="showTable">
        <div *ngIf="showTable" class="table-responsive table-container mt-4">
          <table id="datatable" class="table table-striped table-bordered text-nowrap text-left">
            <thead>
              <tr class="text-left">
                <th class="f600"> {{'header.code-data.table.Type' | translate }} </th>
                <th class="f600"> {{ 'header.code-data.table.Code' | translate }} </th>
                <th class="f600"> {{ 'header.code-data.table.CodeDescription' | translate }} </th>
                <th class="f600"> {{ 'header.code-data.table.CodeSequence' | translate }} </th>
                <th class="f600"> {{ 'header.code-data.table.CodeActive' | translate }} </th>
                <th class="f600"> {{ 'header.code-data.table.CodeProc' | translate }} </th>
                <th width="10%" class="f600 text-center"> {{ 'header.code-data.table.Action' | translate }}</th>
              </tr>
            </thead>
            <tbody id="table_data">
              <tr *ngFor="let codedata of codeList;">
                <td> {{codedata.CdType}} </td>
                <td>{{codedata.CdCode}} </td>
                <td> {{codedata.CdDesc}} </td>
                <td>{{codedata.CdSeq}} </td>
                <td>{{codedata.CdActive}} </td>
                <td>{{codedata.CdProc}} </td>
                <td class="text-center"> <a class="floating" title="Edit" (click)="editdata('true',codedata,codedata)">
                    <i class="fa fa-edit"></i> </a> <a class="floating" title="Delete"
                    (click)="deletee('true',codedata)"> <i class="fas fa-trash"></i>
                  </a> </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</form>